// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__3M-1H","footer":"ReportModalFilter_footer__1i0tY"};